// ** Icons Import
import { useReactOidc } from "@axa-fr/react-oidc-context"
import { useContext, useEffect, useState } from "react"
import { IntlContext, useIntl } from "react-intl"

import { getValueConfig } from "@services/SystemParameterService"

const Footer = () => {
  const intl = useIntl()
  const { oidcUser } = useReactOidc()
  const intlContext = useContext(IntlContext)

  const headers = {
    Authorization: `Bearer ${oidcUser && oidcUser.access_token}`,
    "Accept-Language": intlContext.locale
  }

  const [value, setValue] = useState("")
  const [fetching, setFetching] = useState(true)

  useEffect(() => {
    getValueConfig(headers, { code: "version" })
      .then((res) => {
        setValue(res.data)
      })
  }, [fetching])

  return (
    <p className='clearfix mb-0'>
      <span className='float-md-left d-block d-md-inline-block mt-25'>
        {intl.formatMessage({ id: "COPYRIGHT" })} © {new Date().getFullYear()}{' '}
        <a href='https://cyberlotus.com' target='_blank' rel='noopener noreferrer'>
          CyberLotus
        </a>
        <span className='d-none d-sm-inline-block'>. {intl.formatMessage({ id: "version" })}{value}</span>
      </span>
    </p>
  )
}

export default Footer
